// src/shared/router.js
export const getBuyMembershipPath = ({
  membershipId = "1",
  region,
  city,
  returnTo,
  baseUrl = "",
}) => {
  const search = new URLSearchParams();
  search.set("membershipId", String(membershipId));
  search.set("region", region);
  if (city) search.set("city", city);
  if (returnTo) search.set("return_to", returnTo);

  return `${baseUrl}/checkout?${search.toString()}`;
};

export const getBuySingleTicketPath = ({
  eventId,
  tier,
  region,
  city,
  returnTo,
  baseUrl = "",
}) => {
  const search = new URLSearchParams();
  search.set("eventId", String(eventId));
  search.set("region", region);
  if (tier) search.set("tier", tier);
  if (city) search.set("city", city);
  if (returnTo) search.set("return_to", returnTo);

  return `${baseUrl}/checkout?${search.toString()}`;
};
